import { Routes, Route } from 'react-router-dom';
import { AuthGuard } from './guards/AuthGuard';
import { GuestGuard } from './guards/GuestGuard';
import { SignInPage } from '../pages/SignInPage';
import { OAuthCallbackPage } from '../pages/OAuthCallbackPage';
import { NotFoundPage } from '../pages/NotFoundPage';
import { AppLayout } from '../layouts/AppLayout';

// Lazy load pages for code splitting
import { lazy, Suspense } from 'react';
import { LoadingScreen } from '../components/LoadingScreen';

const HomePage = lazy(() => import('../pages/HomePage'));
const AbsencePage = lazy(() => import('../pages/AbsencePage'));
const ManagerAbsencesPage = lazy(() => import('../pages/ManagerAbsencesPage'));
const AuditorEmployeesPage = lazy(() => import('../pages/AuditorEmployeesPage'));
const AuditorEmployeeDetailPage = lazy(() => import('../pages/AuditorEmployeeDetailPage'));
const TimetrackPage = lazy(() => import('../pages/TimetrackPage'));
const TasksPage = lazy(() => import('../pages/TasksPage'));
const TaskDetailPage = lazy(() => import('../pages/TaskDetailPage'));
const ProjectsPage = lazy(() => import('../pages/ProjectsPage'));
const TeamPage = lazy(() => import('../pages/TeamPage'));
const ProfilePage = lazy(() => import('../pages/ProfilePage'));
const ProductCatalogPage = lazy(() => import('../pages/ProductCatalogPage'));
const FeatureRequestPage = lazy(() => import('../pages/FeatureRequestPage'));
const ChangelogPage = lazy(() => import('../pages/ChangelogPage'));

function AppRoutes() {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <Routes>
        {/* Guest routes - only accessible when not authenticated */}
        <Route element={<GuestGuard />}>
          <Route path="/signin" element={<SignInPage />} />
        </Route>

        {/* OAuth callback route - accessible without auth */}
        <Route path="/oauth/callback" element={<OAuthCallbackPage />} />

        {/* Protected routes - require authentication */}
        <Route element={<AuthGuard />}>
          <Route element={<AppLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/absence" element={<AbsencePage />} />
            <Route path="/manager/absences" element={<ManagerAbsencesPage />} />
            <Route path="/auditor/employees" element={<AuditorEmployeesPage />} />
            <Route path="/auditor/employees/:id" element={<AuditorEmployeeDetailPage />} />
            <Route path="/timetrack" element={<TimetrackPage />} />
            <Route path="/tasks" element={<TasksPage />} />
            <Route path="/tasks/:id" element={<TaskDetailPage />} />
            <Route path="/projects" element={<ProjectsPage />} />
            <Route path="/team" element={<TeamPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/product-catalog" element={<ProductCatalogPage />} />
            <Route path="/feature-request" element={<FeatureRequestPage />} />
            <Route path="/changelog" element={<ChangelogPage />} />
          </Route>
        </Route>

        {/* 404 page */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
}

export default AppRoutes;

